module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reported_post":"Reported/blocked post"}}')
  delete Component.options._Ctor
}
